import { Category } from '@browsing/filters';

export interface State {
    categoryFilter: Category;
    empty: boolean;
}

export const initialState: State = {
    categoryFilter: {
        categories: [],
        id: 0,
        name: '',
        parentId: 0,
        count: 0,
    },
    empty: false,
};
